export default "__VITE_ASSET__CMKU$eet__"